import { Addon } from '@domain/addon';
import { Admission } from '@domain/admission';
import { formatCurrency } from '@utils/price-formatter/price-formatter';

export interface TotalPriceProps {
  offer: Admission;
  addons?: Addon[];
  quantity: number;
  locale: string;
  selectedAddons?: string[];
}

export interface AdmissionPriceProps {
  offer: Admission;
  quantity: number;
}

export const calculateAddonPrice = ({ addons, quantity }: { addons: Addon[]; quantity: number }) => {
  let number = 0;
  number += addons.reduce((sum: number, addon: Addon) => sum + addon.fixedPrice.amount * quantity, 0);
  return number;
};

export const calculateAdmissionPrice = ({ offer, quantity }: AdmissionPriceProps) => {
  if (!offer) return 0;
  let number = 0;
  number += offer.price.amount * quantity;
  return number;
};

export const calculateOnlinePrice = ({ offer, quantity }: AdmissionPriceProps) => {
  if (!offer) return 0;
  let number = 0;
  if (offer.price.onlinePrice) {
    number += offer.price.onlinePrice * quantity;
  }
  return number;
};

export const calculateOfflinePrice = ({ offer, quantity }: AdmissionPriceProps) => {
  if (!offer) return 0;
  let number = 0;
  if (offer.price.offlinePrice) {
    number += offer.price.offlinePrice * quantity;
  }
  return number;
};

export const calculateDDP = (offer: Admission) => {
  return offer?.settings?.italyRegulation?.dirittoPrevendita ?? 0;
};

export const totalOnlinePrice = ({ offer, addons = [], quantity, selectedAddons = [] }: TotalPriceProps) => {
  if (!offer) return 0;
  let number = 0;
  number += calculateOnlinePrice({ offer, quantity });
  if (calculateDDP(offer)) {
    number += calculateDDP(offer) * quantity;
  }
  if (selectedAddons.length > 0)
    number += calculateAddonPrice({
      addons: addons.filter((addon) => selectedAddons.includes(addon.id)) ?? [],
      quantity,
    });
  const currency = offer.price.currency;
  return formatCurrency({
    number,
    currency,
  });
};

export const formatOfflinePrice = ({ offer, quantity }: { offer: Admission; quantity: number }) => {
  let number = 0;
  number += calculateOfflinePrice({ offer, quantity });
  const currency = offer.price.currency;
  return formatCurrency({
    number,
    currency,
  });
};

export const formatDDP = ({ offer, quantity }: { offer: Admission; quantity: number }) => {
  const currency = offer.price.currency;
  const number = calculateDDP(offer) * quantity;
  return formatCurrency({
    number,
    currency,
  });
};
